import { Button, Group } from '@mantine/core';
import React, { useRef, useState, useEffect, useMemo } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { useTranslation } from 'react-i18next';
import MentionableEditor, {
    MentionableEditorRef,
} from '@/features/comment/components/MentionableEditor';
import { convertJsonToPlainTextWithMentions } from '@/features/comment/utils/mentionUtils';
import { useAddFeedbackComment } from '../services/useFeedbackQueries';
import { useCurrentWorkspace } from '@/features/workspace';

interface FeedbackCommentFormProps {
    parentId?: string;
    targetId: string;
    onCommentAdded?: () => void;
}

export const FeedbackCommentForm: React.FC<FeedbackCommentFormProps> = ({
    parentId,
    targetId,
    onCommentAdded,
}) => {
    const { t } = useTranslation('comment');
    const { user } = useAuthStore();
    const { currentWorkspace } = useCurrentWorkspace(user?.id);
    const [comment, setComment] = useState('');
    const addCommentMutation = useAddFeedbackComment();

    // 불필요한 재렌더링 방지
    const mentionableUsers = useMemo(() => [], []);
    // const { data: mentionableUsers, isLoading: loadingUsers } =
    //     useMentionableUsers('feedback', targetId);
    // const [mentionedUsers, setMentionedUsers] = useState<CommentMention[]>([]);

    const editorRef = useRef<MentionableEditorRef>(null);

    useEffect(() => {
        if (addCommentMutation.isSuccess && onCommentAdded) {
            onCommentAdded();
        }
    }, [addCommentMutation.isSuccess, onCommentAdded]);

    const handleFileSelect = (file: File) => {
        console.log('Selected file:', file.name);
        // TODO: File Upload
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (comment.trim() && targetId && user?.id) {
            if (comment.trim() && targetId && user?.id) {
                addCommentMutation.mutate({
                    content: comment,
                    parentId,
                    feedbackId: targetId,
                    notiParams: {
                        workspaceId: currentWorkspace?.id,
                        workspaceName: currentWorkspace?.name,
                        workspaceImageUrl: currentWorkspace?.profile_image_url,
                    },
                    // mentions: mentionedUsers,
                });

                // 상태 초기화
                setComment('');
                // setMentionedUsers([]);
                editorRef.current?.clearContent();
            }
        }
    };

    return (
        <Group
            component="form"
            gap="xs"
            ml={parentId ? 22 : 0}
            mt={parentId ? 12 : 0}
            onSubmit={handleSubmit}
        >
            <MentionableEditor
                ref={editorRef}
                mentionable={false}
                mentionableUsers={mentionableUsers}
                loadingUsers={false}
                // loadingUsers={loadingUsers}
                onChange={(content, mentions, json) => {
                    // setMentionedUsers(
                    //     mentions.map(mention => ({
                    //         user_id: mention.id,
                    //         user_name: mention.label,
                    //     }))
                    // );
                    const plainTextWithMentions =
                        convertJsonToPlainTextWithMentions(json);
                    setComment(plainTextWithMentions);
                }}
                autoFocus={parentId ? true : false}
            />
            <Button
                type="submit"
                variant="filled"
                size="sm"
                radius="md"
                disabled={
                    !comment.trim() || addCommentMutation.isPending || !user
                }
            >
                {t('common:action.enter')}
            </Button>
        </Group>
    );
};
